"use client";

export default function ProcessSection() {
  const steps = [
    {
      num: "1",
      title: "Call & Describe",
      desc: "Tell us the damage.",
    },
    {
      num: "2",
      title: "Arrive On-Site",
      desc: "Same-day arrival. Materials included.",
    },
    {
      num: "3",
      title: "Secure Opening",
      desc: "Hurricane plywood, through-bolted, weatherproofed.",
    },
    {
      num: "4",
      title: "Documentation",
      desc: "Photos for insurance or police.",
    },
  ];

  return (
    <section className="bg-white py-20 px-4 md:px-6">
      <div className="max-w-[1080px] mx-auto">
        <h2 className="text-2xl md:text-[32px] font-bold text-secondary text-center mb-12">
          Our Process
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((s) => (
            <div key={s.num} className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary text-white font-bold text-lg mb-4">
                {s.num}
              </div>
              <h3 className="text-base font-bold text-secondary mb-2">{s.title}</h3>
              <p className="text-sm text-gray-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}